import { createAction, props } from '@ngrx/store';

export const cacheHttpCall = createAction('[PaceOffline] cache http call', props<{ url: string; response: unknown }>());
